import React, {SetStateAction, useEffect, useState} from 'react';
import {IFields} from "../../../Interfaces/IGeneral";
import {IDataCreate} from "../../../../../models/data/data.module";

interface IMultiselectFormProps {
    field: IFields,
    fieldIndex: number,
    data?: Array<IDataCreate>,
    setData?: React.Dispatch<SetStateAction<Array<IDataCreate[]> | null>>;
    pageNumber: number
}

const ESingleSelectBoxFormField = (props: IMultiselectFormProps) => {

    const [text, setText] = useState<string>("")

    useEffect(() => {
        if (props.data && props.data[props.fieldIndex] && props.data[props.fieldIndex].value !== undefined) {
            setText(props.data[props.fieldIndex].value)
        }
    }, [])

    const textChangeHandler = (e: any) => {
        if (props.data && props.setData) {
            let changedValues = [...props.data]
            if(e.target.value === text) {
                setText("")
            } else {
                setText(e.target.value)
            }
            changedValues[props.fieldIndex].value = e.target.value
            props.setData((prevState: any) => {
                let newState = [...prevState];
                newState[props.pageNumber] = changedValues;
                return newState;
            });
        }
    }

    return (
        <div className="ESelectBox">
            <div className="MPage__drop-target__field-label">
                {props.field.name}{props.field.required ? "*" : ""}
            </div>
            <div className="ESelectBox__inner">
                {JSON.parse(props.field.valuesToBeSelected).map(
                        (value: string, valueIndex: number, valueArr: string[]) => {
                            return (
                                <div key={value + valueIndex}
                                     className={"ESelectBox__inner__option " + (valueArr.length % 2 !== 0 && valueIndex == valueArr.length - 1 ? " span" : "") + (text === value ? " selected" : "")}
                                     onClick={()=> {
                                         textChangeHandler({target: {value: value}})
                                     }
                                     }
                                >
                                    {value}
                                </div>
                            );
                        },
                    )}
            </div>
        </div>
    )
};

export default ESingleSelectBoxFormField;